import { useState, useRef, useEffect } from 'react'
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import './Hero.css'; // Adjust the path as necessary
import Lottie from 'react-lottie';
import logoSvg from '../assets/logo.svg';
import logonameSvg from '../assets/logoname.svg';
import { RadioGroup } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/20/solid'
import logotext from '../assets/logotext.svg';
import { useSwipeable } from 'react-swipeable';

const frequencies = [
  { value: 'monthly', label: 'Monthly', priceSuffix: '/month' },
  { value: 'annually', label: 'Annually', priceSuffix: '/year' },
]
const tiers = [
  {
    name: 'Personal',
    id: 'tier-startup',
    href: '/signup',
    price: { monthly: '$4.99', annually: '$49.99' },
    description: 'Perfect for individuals or small-businesses.',
    features: [
      'Dedicated Inboxly public mailbox',
      'Personalized AI Inboxly assistant',
      'Daily digest email of all messages',
      'AI automated responses',
      'Smart filtering',
    ],
    mostPopular: true,
  },
  {
    name: 'Enterprise',
    id: 'tier-enterprise',
    href: '/signup',
    price: { monthly: 'Enquire', annually: 'Enquire' },
    description: 'Dedicated mailbox for larger enterprises, influencers and high-volume events.',
    features: [
      'Multiple Inboxly public mailboxes',
      'Personalized AI Inboxly assistant',
      'Daily digest email of all messages',
      'AI automated responses',
      'Smart filtering',
      'Enhanced usage/volume capacity',
    ],
    mostPopular: false,
  },
]

const navigation = [
  { name: 'Home', href: '#' },
  { name: 'How Does It Work?', href: '#'},
  { name: 'Testimonials', href: '#'},
];


const navigationfooter = {
  main: [
    { name: 'About', href: '#' },
    { name: 'Privacy Policy', href: '/privacy' },
  ],
  social: [
    {
      name: 'Facebook',
      href: '#',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'Instagram',
      href: '#',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'X',
      href: '#',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
        </svg>
      ),
    },
    {
      name: 'GitHub',
      href: '#',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'YouTube',
      href: '#',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
  ],
}


const featuredTestimonial = {
  body: 'Discovering Inboxly was a revelation—no more drowning in messages! Its AI assistant keeps my inbox tidy and can even reply for me, so I can focus on what truly matters. Absolute game-changer for my workflow!',
  author: {
    name: 'Lisa Phillips',
    handle: 'Freelance Developer',
    imageUrl:
      'https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=1024&h=1024&q=80',
  },
}
const testimonials = [
  [
    [
      {
        body: 'Inboxly has transformed my day-to-day operations. The clarity it brings to my overall communications allows me to focus more on growing my business. It’s like having a personal assistant who knows exactly what I need.',
        author: {
          name: 'Michelle Alexander',
          handle: 'Small Business Owner',
          imageUrl:
            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        },
      },
      // More testimonials...
    ],
    [
      {
        body: 'Balancing school, social life, and building an online presence used to overwhelm my daily routine. Since I started using Inboxly.me, managing messages from all my social media platforms has become a breeze. It summarizes everything important, so I never miss a beat and can engage with my audience more effectively. Inboxly.me is like the ultimate digital assistant for anyone trying to make it big online!',
        author: {
          name: 'Ruby Spencer',
          handle: 'Student',
          imageUrl:
            'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        },
      },
      // More testimonials...
    ],
  ],
  [
    [
      {
        body: 'Since using Inboxly, my project communications are streamlined like never before. I spend less time sorting emails and more on creativity. A game-changer for freelancers',
        author: {
          name: 'Tim Cape',
          handle: 'Photographer',
          imageUrl:
            'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        },
      },
      // More testimonials...
    ],
    [
      {
        body: 'Receiving messages across platforms used to be my biggest time sink. Thanks to Inboxly, it is now my productivity tool. Managing communications has never been easier, letting me focus on the creative aspects of my work.',
        author: {
          name: 'Leonard Littler',
          handle: 'Indiehacker',
          imageUrl:
            'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        },
      },
      // More testimonials...
    ],
  ],
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const userJourneySteps = [
  {
    animationData: require('../clutter.json'),
    text: 'Strangers often struggle to find the right way to reach you with new opportunities. Even when they do connect, you\'re left sifting through a pile of irrelevant messages across multiple platforms just to find the valuable ones.',
  },
  {
    animationData: require('../url.json'),
    text: 'Why not simplify your reachability, with one simple, shareable URL that you can leave in your bios?',
  },
  {
    animationData: require('../mailbox.json'),
    text: 'In minutes, you could have your own public mailbox... where anyone can message you. Simply leave your link in your bios.',
  },
  {
    animationData: require('../robot.json'),
    text: 'With your very own AI assistant, that reads and replies for you - saving you time, skipping the clutter and spam, making sure you never miss an important message again.',
  },
  {
    animationData: require('../connect.json'),
    text: 'Have an existing email you want to integrate? No problem, you can keep it all in one place. We enable integration with any email provider.',
  },
  {
    animationData: require('../mail.json'),
    text: 'Your AI will also deliver a personalized summary to you at the end of the day...',
  },
  {
    animationData: require('../relax.json'),
    text: 'So you can do more of what counts, and keep your personal inboxes clean.',
  },
];

export default function Hero() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animation, setAnimation] = useState('rollIn');
  const testimonialsRef = useRef(null);
  const howItWorksRef = useRef(null);
  const homeRef = useRef(null);
  const [frequency, setFrequency] = useState(frequencies[0])
  const handlers = useSwipeable({
    onSwipedLeft: () => setCurrentStep((s) => (s + 1) % userJourneySteps.length),
    onSwipedRight: () => setCurrentStep((s) => (s === 0 ? userJourneySteps.length - 1 : s - 1)),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

const scrollToTestimonials = () => {
  testimonialsRef.current.scrollIntoView({ behavior: 'smooth' });
};
const scrollToHome = (e) => {
  e.preventDefault();
  homeRef.current?.scrollIntoView({ behavior: 'smooth' });
};

const scrollToHowItWorks = (e) => {
  howItWorksRef.current?.scrollIntoView({ behavior: 'smooth' });
};

  const suffixes = ['professionals', 'mybusiness', 'freelancers', 'events', 'fundraisers', 'individuals'];
  const colors = ['text-blue-500', 'text-green-500', 'text-red-500', 'text-yellow-500', 'text-orange-500', 'text-purple-500'];
  const [currentStep, setCurrentStep] = useState(0);

  const defaultOptions = (animData) => ({
    loop: false,
    autoplay: false,
    animationData: animData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });

  const nextStep = () => {
    setCurrentStep((prevStep) => (prevStep + 1) % userJourneySteps.length);
  };

  const prevStep = () => {
    setCurrentStep((prevStep) =>
      prevStep === 0 ? userJourneySteps.length - 1 : prevStep - 1
    );
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setAnimation('rollOut');
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % suffixes.length);
        setAnimation('rollIn');
      }, 500); // Half the interval to switch the text mid-way
    }, 3000);

    return () => clearInterval(intervalId);
  }, []);
  

  const rollInStyle = {
    animation: `${animation} 0.5s forwards`
  };

  const animationName = animation === 'rollIn' ? 'rollIn' : 'rollOut';

  return (
    <div className="bg-white">
      <header className="absolute inset-x-0 top-0 z-50">
        <nav className="flex items-center justify-between p-6 lg:px-8" aria-label="Global">
          <div className="flex lg:flex-1">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">Inboxly</span>
              <img
                className="h-10 w-auto"
                src={logonameSvg}
                alt=""
              />
            </a>
          </div>

                    {/* HTML code for verification */}
                    <a href="https://theresanaiforthat.com/ai/inboxly/?ref=featured&v=1250710" target="_blank" rel="nofollow">
          </a>

          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
  {navigation.map((item) => {
    if (item.name === 'Home') {
      return (
        <a
          key={item.name}
          href={item.href}
          onClick={scrollToHome}
          className="text-sm font-semibold leading-6 text-gray-900 cursor-pointer"
        >
          {item.name}
        </a>
      );
    } else if (item.name === 'How Does It Work?') {
      return (
        <a
          key={item.name}
          href={item.href}
          onClick={scrollToHowItWorks}
          className="text-sm font-semibold leading-6 text-gray-900 cursor-pointer"
        >
          {item.name}
        </a>
      );
    } else if (item.name === 'Testimonials') {
      return (
        <a
          key={item.name}
          href={item.href}
          onClick={scrollToTestimonials}
          className="text-sm font-semibold leading-6 text-gray-900 cursor-pointer"
        >
          {item.name}
        </a>
      );
    } else {
      return (
        <a
          key={item.name}
          href={item.href}
          className="text-sm font-semibold leading-6 text-gray-900"
        >
          {item.name}
        </a>
      );
    }
  })}
</div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <a href="/login" className="text-sm font-semibold leading-6 text-gray-900">
              Log in <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </nav>
        <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a href="#" className="-m-1.5 p-1.5">
                <span className="sr-only">Inboxly</span>
                <img
                  className="h-8 w-auto"
                  src={logonameSvg}
                  alt=""
                />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
                <div className="py-6">
                  <a
                    href="/login"
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                  >
                    Log in
                  </a>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>

      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
{/* Logo Container */}
<div className="text-center mt-10 lg:mt-20">
  <img
    src={window.innerWidth >= 768 ? logoSvg : logotext}
    alt="Inboxly Logo"
    className={`mx-auto h-auto ${
      window.innerWidth >= 768 ? 'w-24 sm:w-32' : 'w-48 sm:w-64'
    }`}
  />
</div>

<div
  className={`mx-auto max-w-2xl ${
    window.innerWidth >= 768 ? 'pt-10 sm:pt-10 lg:pt-10' : 'pt-0'
  } pb-32 sm:pb-32 lg:pb-32`}
>
  <div className="hidden sm:mb-8 sm:flex sm:justify-center">
    <div
      ref={homeRef}
      className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20"
    >
      Exclusive 10-day free trial offer{' '}
      <a href="/signup" className="font-semibold text-indigo-600">
        <span className="absolute inset-0" aria-hidden="true" />
        Get Started <span aria-hidden="true">&rarr;</span>
      </a>
    </div>
  </div>

  <div className="text-center">
    <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl hero-title">
      {window.innerWidth >= 768 ? (
        <span
          className="inline-grid items-center"
          style={{
            gridTemplateColumns: `auto ${
              window.innerWidth >= 640 ? '1.5rem' : '0.75rem'
            } ${window.innerWidth >= 640 ? '18rem' : '7rem'}`,
          }}
        >
          <span className="text-right text-2xl sm:text-6xl">inboxly.me</span>
          <span className="text-center text-2xl sm:text-6xl">/</span>
          <span className="text-left rotating-text-container">
            <span
              className={`${colors[currentIndex]} rotating-text inline-block`}
              style={{ animationName: animationName }}
            >
              {suffixes[currentIndex]}
            </span>
          </span>
        </span>
      ) : null}
    </h1>
          <p className="mt-6 text-lg leading-8 text-gray-600">
          Why are you so hard to reach? Stop missing valuable new opportunities with Inboxly, your AI mailbox that organizes, prioritizes, and responds to messages from all platforms. Leave your Inboxly link in your bios and become <span style={{ fontStyle: 'italic', fontWeight: 'bold' }}>limitlessly</span> reachable without sacrificing privacy or time. Transform your approach to communication—see what you’ve been missing. </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <a
                href="/signup"
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Get Your Mailbox
              </a>
              <a href="#" onClick={scrollToHowItWorks} className="text-sm font-semibold leading-6 text-gray-900">
                Learn more <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>
        <div className="mx-auto max-w-xl text-center mb-16">
  <h2 className="text-lg font-semibold leading-8 tracking-tight text-indigo-600">90-Second Demo</h2>
  <div className="mt-4 px-4 sm:px-0">
  <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden shadow-lg bg-purple-50">
    <video
      className="w-full h-full object-cover rounded-lg"
      src="https://hermesimages.s3.amazonaws.com/protodemo.mp4" // Direct URL to S3
      controls
    ></video>
  </div>
</div>
</div>
<div className="mx-auto max-w-xl text-center">
  <h2 ref={howItWorksRef} className="text-lg font-semibold leading-8 tracking-tight text-indigo-600">How does it work?</h2>
</div>
<div className="carousel-container relative" {...handlers}>
  <div className="carousel-content">
    <div className="lottie-container">
      <Lottie options={defaultOptions(userJourneySteps[currentStep].animationData)} />
    </div>
    <p className="mt-6 text-lg leading-8 text-gray-600 text-center">{userJourneySteps[currentStep].text}</p>
  </div>
  
  {/* Dot Indicators */}
  <div className="dot-indicators flex justify-center p-4">
  {userJourneySteps.map((_, index) => (
    <span key={index}
          className="dot cursor-pointer rounded-full mx-1"
          style={{
            backgroundColor: currentStep === index ? '#717171' : '#bbb' // Active dot color
          }}
          onClick={() => setCurrentStep(index)}>
    </span>
  ))}
</div>
</div>
      <div className="bg-white py-24 sm:py-32">
  <div className="mx-auto max-w-7xl px-6 lg:px-8">
    <div className="mx-auto max-w-4xl text-center">
      <h2 className="text-base font-semibold leading-7 text-indigo-600">Pricing</h2>
      <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        Low cost with high impact.
      </p>
    </div>
    <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600">
      Choose an affordable plan that’s packed with the best Inboxly features.
    </p>
    <div className="mt-16 flex justify-center">
    </div>
    <div className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-2">
      {tiers.map((tier) => (
        <div
          key={tier.id}
          className={classNames(
            tier.mostPopular ? 'ring-2 ring-indigo-600' : 'ring-1 ring-gray-200',
            'rounded-3xl p-8 xl:p-10'
          )}
        >
          <div className="flex items-center justify-between gap-x-4">
            <h3
              id={tier.id}
              className={classNames(
                tier.mostPopular ? 'text-indigo-600' : 'text-gray-900',
                'text-lg font-semibold leading-8'
              )}
            >
              {tier.name}
            </h3>
            {tier.mostPopular ? (
              <p className="rounded-full bg-indigo-600/10 px-2.5 py-1 text-xs font-semibold leading-5 text-indigo-600">
                Popular 🔥
              </p>
            ) : null}
          </div>
          <p className="mt-4 text-sm leading-6 text-gray-600">{tier.description}</p>
          <p className="mt-6 flex items-baseline gap-x-1">
            <span className="text-4xl font-bold tracking-tight text-gray-900">{tier.price[frequency.value]}</span>
            <span className="text-sm font-semibold leading-6 text-gray-600">{frequency.priceSuffix}</span>
          </p>
          <a
            href={tier.href}
            aria-describedby={tier.id}
            className={classNames(
              tier.mostPopular
                ? 'bg-indigo-600 text-white shadow-sm hover:bg-indigo-500'
                : 'text-indigo-600 ring-1 ring-inset ring-indigo-200 hover:ring-indigo-300',
              'mt-6 block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
            )}
          >
            Subscribe
          </a>
          <ul role="list" className="mt-8 space-y-3 text-sm leading-6 text-gray-600 xl:mt-10">
            {tier.features.map((feature) => (
              <li key={feature} className="flex gap-x-3">
                <CheckIcon className="h-6 w-5 flex-none text-indigo-600" aria-hidden="true" />
                {feature}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
</div>
        <div className="relative isolate bg-white pb-32 pt-24 sm:pt-32">
      <div
        className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl"
        aria-hidden="true"
      >
        <div
          className="ml-[max(50%,38rem)] aspect-[1313/771] w-[82.0625rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc]"
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
        />
      </div>
      <div
        className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end"
        aria-hidden="true"
      >
        <div
          className="ml-[-22rem] aspect-[1313/771] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] xl:ml-0 xl:mr-[calc(50%-12rem)]"
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
        />
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={testimonialsRef} className="mx-auto max-w-xl text-center">
          <h2 className="text-lg font-semibold leading-8 tracking-tight text-indigo-600">Testimonials</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Inboxly has already revolutionised efficiency for so many
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 grid-rows-1 gap-8 text-sm leading-6 text-gray-900 sm:mt-20 sm:grid-cols-2 xl:mx-0 xl:max-w-none xl:grid-flow-col xl:grid-cols-4">
          <figure className="rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/5 sm:col-span-2 xl:col-start-2 xl:row-end-1">
            <blockquote className="p-6 text-lg font-semibold leading-7 tracking-tight text-gray-900 sm:p-12 sm:text-xl sm:leading-8">
              <p>{`“${featuredTestimonial.body}”`}</p>
            </blockquote>
            <figcaption className="flex flex-wrap items-center gap-x-4 gap-y-4 border-t border-gray-900/10 px-6 py-4 sm:flex-nowrap">
              <img
                className="h-10 w-10 flex-none rounded-full bg-gray-50"
                src={featuredTestimonial.author.imageUrl}
                alt=""
              />
              <div className="flex-auto">
                <div className="font-semibold">{featuredTestimonial.author.name}</div>
                <div className="text-gray-600">{`${featuredTestimonial.author.handle}`}</div>
              </div>
              <img className="h-10 w-auto flex-none" src={featuredTestimonial.author.logoUrl} alt="" />
            </figcaption>
          </figure>
          {testimonials.map((columnGroup, columnGroupIdx) => (
            <div key={columnGroupIdx} className="space-y-8 xl:contents xl:space-y-0">
              {columnGroup.map((column, columnIdx) => (
                <div
                  key={columnIdx}
                  className={classNames(
                    (columnGroupIdx === 0 && columnIdx === 0) ||
                      (columnGroupIdx === testimonials.length - 1 && columnIdx === columnGroup.length - 1)
                      ? 'xl:row-span-2'
                      : 'xl:row-start-1',
                    'space-y-8'
                  )}
                >
                  {column.map((testimonial) => (
                    <figure
                      key={testimonial.author.handle}
                      className="rounded-2xl bg-white p-6 shadow-lg ring-1 ring-gray-900/5"
                    >
                      <blockquote className="text-gray-900">
                        <p>{`“${testimonial.body}”`}</p>
                      </blockquote>
                      <figcaption className="mt-6 flex items-center gap-x-4">
                        <img className="h-10 w-10 rounded-full bg-gray-50" src={testimonial.author.imageUrl} alt="" />
                        <div>
                          <div className="font-semibold">{testimonial.author.name}</div>
                          <div className="text-gray-600">{`${testimonial.author.handle}`}</div>
                        </div>
                      </figcaption>
                    </figure>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
    <footer className="bg-white">
      <div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
        <nav className="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
          {navigationfooter.main.map((item) => (
            <div key={item.name} className="pb-6">
              <a href={item.href} className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                {item.name}
              </a>
            </div>
          ))}
        </nav>
        <div className="mt-10 flex justify-center space-x-10">
          {navigationfooter.social.map((item) => (
            <a key={item.name} href={item.href} className="text-gray-400 hover:text-gray-500">
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </a>
          ))}
        </div>
        <p className="mt-10 text-center text-xs leading-5 text-gray-500">
          &copy; 2024 NNL. All rights reserved.
        </p>
      </div>
    </footer>
      </div>
    </div>
  )
}
